import axios from './intercept.js';
// 设置baseUrl
let baseUrl = 'http://xiehuiapi.zjbinfo.com';
const env = process.env.NODE_ENV;
if (env === 'development') {
    baseUrl = '/other';
}

const getAccountModel = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetAccountModel', {params});
const updatePwd = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/UpdatePwd' + params.url);
const editAccount = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/EditAccount', params);
const addGongxiang = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddGongxiang', params);
// 2、上传专报信息
const addJiaoliu = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddJiaoliu', params);
const getListbyfaqiren = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetListbyfaqiren', {params});
const dddFengcai = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddFengcai', params);
const editFengcai = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/EditFengcai', params);
const getMyFengcai = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetMyFengcai', {params});
const editGongxiang = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/EditGongxiang', params);
const editJiaoliu = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/EditJiaoliu', params);
const addFoodShop = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddFoodShop', params);
const getMyFoodShop = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetMyFoodShop', {params});
const editFoodShop = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/EditFoodShop', params);
// 获取菜品
const getDishesList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetDishesList', {params});
const addDishes = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/AddDishes', params);
const getDishesModel = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetDishesModel', {params});
const editDishes = params =>
    axios.post(baseUrl + '/api/ZhuJingBanXieHui/EditDishes', params);
// 活动
const getMyBaoimng = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetMyBaoimng', {params});
const getDownCount = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetDownCount', {params});  
const getDownList = params =>
    axios.get(baseUrl + '/api/ZhuJingBanXieHui/GetDownList', {params});  
       
    
export {
    baseUrl,
    getAccountModel,
    updatePwd,
    editAccount,
    addGongxiang,
    addJiaoliu,
    getListbyfaqiren,
    dddFengcai,
    editFengcai,
    getMyFengcai,
    editGongxiang,
    editJiaoliu,
    addFoodShop,
    getMyFoodShop,
    editFoodShop,
    getDishesList,
    addDishes,
    getDishesModel,
    editDishes,
    getMyBaoimng,
    getDownCount,
    getDownList,
};